<template>
    <div id="forminput" class="th">
            <div  v-for="(components,componentsIndex) in propsComponentForm" :key="componentsIndex" class="is-marginless"
            :class="{basicprofile : components.componentName == 'Basic profile',deltransform : components.componentName == 'Social profiles',introductioncss : components.componentName == 'Introduction',Languagecss : components.componentName == 'Language'}">
                <p  :id="'M'+components.key" v-if="typeof components !== 'undefined'" class="is-size-5 th has-text-weight-normal has-text-left fontbold2"   :style="indent">{{components.componentName}}</p>
                <div v-if="typeof components !== 'undefined'"> 
                   
                    <div v-for="(component,componentDataIndex) in components.componentData" :key="componentDataIndex" :class="{ perrate :  component.name == 'hourlyRateAmount' ,  hourrate: component.name == 'hourlyRate', whoareu: component.name == 'whoAreYou', loveVolunteer : component.name == 'loveVolunteer',defaultcss : component.name != 'genderMentor' , gendercsstitle: component.name == 'genderMentor'}" :style="indent"> 
                            <!-- {{ component.name }} -->
                        <div :class="{Othertitle :component.name == 'otherinvest'}"   v-if="component.type === 'text' && component.options.hidden === false && checkMathId(component.display.matchid,matchId)" class="pd-3 has-text-left w-60">
                                
                            <div class="pd-y-2">
                                
                                <p v-if="!component.options.hideLabel && component.display.label !== ''" class="is-size-6 th is-flex align-center">{{component.display.label}}
                                    <b-tooltip  v-if="component.options.toolTip !== ''" :label="component.options.toolTip" size="is-small" class="mg-l-1" type="is-dark">
                                        <b-icon pack="fas" size="is-small" icon="question-circle" class="has-text-grey-light"></b-icon>
                                    </b-tooltip>
                                </p>
                            </div>
                            <div>
                                <place-autocomplete-field 
                                    v-if="component.display !== null && component.display.type === 'addrees'"
                                     v-model="input[component.name]"
                                    :placeholder="component.display.placeholder" 
                                    class="input-custom"
                                    api-key="AIzaSyAhSv9zWvisiTXRPRw6K8AE0DCmrRMpQcU">
                                </place-autocomplete-field>
                                <b-field 
                                    v-else
                                    label="" 
                                    :message="valid[component.name].valid === true?component.validation.errorMsg:component.display.description" 
                                    :type="valid[component.name].valid === true?'is-danger':''"
                                >
                                    <b-input  
                                        :placeholder="component.display.placeholder"
                                        :type="(component.display.password)?'password':''"
                                        icon-pack="fas"
                                        :icon="(component.options.leftIcon)?component.options.leftTypeIcon:''"
                                        :name="'input'+componentsIndex+componentDataIndex+component.name"
                                        :minlength="component.validation.min"
                                        :maxlength="component.validation.max"
                                        :readonly="component.options.readOnly"
                                        v-model="input[component.name]"
                                        @input="checkValidate(component.name,component.validation)"
                                        :customClass="component.options.customClass"
                                    ></b-input>
                                </b-field>
                            </div>
                        </div>
                        <div v-if="component.type === 'textarea' && checkMathId(component.display.matchid,matchId)" class="pd-3 has-text-left w-60">
                            <div class=" pd-y-2">
                                <p class="is-size-6 th" v-if="component.display.label !== ''">{{component.display.label}}</p>
                            </div>
                            
                            <div>
                                <b-field 
                                    label="" 
                                    class="position-unset"
                                    :message="valid[component.name].valid === true?component.validation.errorMsg:component.display.description" 
                                    :type="valid[component.name].valid === true?'is-danger':''"
                                >
                                    <b-input type="textarea"
                                        :minlength="component.validation.min"
                                        :maxlength="component.validation.max"
                                        v-model="input[component.name]"
                                        :name="'input'+componentsIndex+componentDataIndex+component.name"
                                        @input="checkValidate(component.name,component.validation)"
                                        :placeholder="component.display.placeholder">
                                    </b-input>
                                </b-field>
                            </div>
                        </div>
                        <div :class="{customselect : component.display.label == 'Hourly Rate' }" v-if="component.type === 'select' && checkMathId(component.display.matchid,matchId)" class="pd-3 has-text-left w-60">
                           <div class="pd-y-2">
                                <p class="is-size-6 th" v-if="component.display.label !== ''">{{component.display.label}}</p>
                            </div>
                            <div>

                                <div v-if="component.display.choice === 'phoneNumber'" >
                                    <FormInputData
                                        :component="component"
                                        :input="input"
                                        :valid="valid"
                                        :checkValidatePhoneNumber="checkValidatePhoneNumber"/>
                                </div> 
                                 <b-dropdown 
                                 class="w-100"
                                aria-role="list" 
                                 v-else-if="component.display.choice === 'currency'"
                                >
                                    <button class="button w-100 h-2-50"  slot="trigger">
                                        <div v-if="input[component.name] != null && typeof input[component.name].label != 'undefined'" class="w-100 is-flex is-justify-center is-align-center">
                                            <div class="currency-flag mg-r-5" :class="'currency-flag-'+toLower(input[component.name].label)"></div>
                                            <span>{{input[component.name].label}}</span>
                                        <b-icon icon="menu-down"></b-icon>
                                        </div>
                                        <div v-else class="has-text-grey-lighter">
                                            Select currency 
                                        </div>
                                        <div class="cursor-down has-text-grey-lighter">
                                           <i class="fas fa-angle-down"></i>
                                        </div>
                                    </button>
                                    <div class="list-menu">
                                        <b-dropdown-item 
                                        v-if="renderDropdown"
                                        aria-role="menuitem" 
                                        v-for="(select,index) in component.display.value" :key="index" 
                                        :value="select"
                                        @click='changeCurrent(select,component.name)'>
                                            <div class="currency-flag mg-r-5" :class="'currency-flag-'+toLower(select.label)"></div>
                                            {{select.label}}
                                        </b-dropdown-item>
                                    </div>
                                    </b-dropdown>
<!--                                 <b-field 
                                     v-else-if="component.display.choice === 'currency'"
                                    label="" 
                                    :message="(valid[component.name].valid === true)?component.validation.errorMsg:component.display.description" 
                                    :type="(valid[component.name].valid === true)?'is-danger':''"
                                >
                                    <b-select 

                                        v-model="input[component.name]"
                                        :placeholder="component.display.placeholder" 
                                        @input="checkValidateRequired(component.name,component.validation.required)"
                                        expanded
                                    >
                                        <option v-for="(select,index) in component.display.value" :key="index" :value="select">
                                            <div class="currency-flag" :class="'currency-flag-'+toLower(select.label)"></div>{{select.label}}
                                        </option>
                                    </b-select>
                                </b-field> -->
                                <b-field 
                                    v-else
                                    label="" 
                                    :message="(valid[component.name].valid === true)?component.validation.errorMsg:component.display.description" 
                                    :type="(valid[component.name].valid === true)?'is-danger':''"
                                >
                                    <b-select 
                                        v-model="input[component.name]"
                                        :placeholder="component.display.placeholder" 
                                        @input="checkValidateRequired(component.name,component.validation.required)"
                                        expanded
                                    >
                                        <option v-for="(select,index) in component.display.value" :key="index" :value="select">{{select.label}}</option>
                                    </b-select>
                                </b-field>
                            </div>
                        </div>

                            <!-- {{imgimgimgimg}} -->
                          <!-- {{ input }} -->
                          
                        <FieldUpload  
                            v-if="component.type === 'file' && checkMathId(component.display.matchid,matchId)" 
                            :component="component" 
                            :input="input"
                            :valid="valid"
                            :delFile="delFile"
                            :value="(component.options.multiple === false)?input[component.name]:getData(input[component.name])"
                            @checkValidateRequired="checkValidateRequired"
                        />
                        <div v-if="component.type === 'date' && checkMathId(component.display.matchid,matchId)" class="pd-3 has-text-left w-60">
                            <div class="has-text-left pd-y-2">
                                <p v-if="component.display.label !== ''" class="is-size-6 th">{{component.display.label}}</p>
                            </div>
                            <div>
                                <date-picker
                                    class="h-2-50"
                                     type="date"
                                     :placeholder="component.display.placeholder"
                                    @input="checkValidateRequired(component.name,component.validation)"
									:lang="'en'" 
									v-model="input[component.name]"
									:range="component.options.range" 
                                    :format="'DD-MM-YYYY'"
									:first-day-of-week="component.options.datePicker.firstDayOfWeek" 
									:not-before="component.options.datePicker.notBefore" 
									:not-after="component.options.datePicker.notAfter" 
									:default-value="component.options.datePicker.defaultDate"
                                    slot='<i class="far fa-calendar-alt"></i>'
                                />
									<!-- :type="component.options.type"  -->
									<!-- :format="component.options.format"  -->
                                <p class="th is-size-7 mg-t-5" 
                                    :class="{'has-text-danger':valid[component.name].valid === true}"
                                    v-if="valid[component.name].valid === true"
                                >{{component.validation.errorMsg}}</p>
                            </div>
                        </div>
                        <div :class="{gendercss :component.display.label == 'Gender' }" v-if="component.type === 'radio' && checkMathId(component.display.matchid,matchId)" class="pd-3 has-text-left">
                         
                           <div class="pd-y-2"> 
                                <p  class="is-size-6 th has-text-weight-normal" v-if="component.display.label !== ''">{{component.display.label}}</p>
                            </div>
                            <div>
                                <div v-for="(value,index) in component.display.value" :key="index" class="field" >
                                    <div class="is-flex align-center">
                                        <b-radio 
                                            v-model="input[component.name]['data']"  
                                            @input="checkValidateRequiredObject(component.name,component.validation.required),$emit('setMatchId',component.display.value,value,components,'radio')"
                                            @click.native="(input[component.name].data !== null && value.label !== input[component.name].data.label)?clearRadio(input[component.name],component.name,component.display.value):input[component.name].des = input[component.name].des"
                                            :name="'input'+componentsIndex+componentDataIndex+component.name"
                                            :native-value="{label:value.label,value:value.value,userValue:value.userValue,index:index}"
                                            type="is-dark"
                                        >
                                            <p class="th">{{value.label}}</p>
                                        </b-radio>
                                        <b-field 
                                            v-if="value.userValue === true" 
                                            :message="valid[component.name+'UserValue'+index].valid === true?'Please fill in a message.':''" 
                                            :type="valid[component.name+'UserValue'+index].valid === true?'is-danger':''"
                                            class="mg-l-2 mw-500 fixed-error-msg"
                                        >
                                            <b-input 
                                                expanded
                                                v-if="input[component.name].data !== null && value.label === input[component.name].data.label"
                                                placeholder=""
                                                icon-pack="fas"
                                                v-model="input[component.name].des" 
                                                @keyup.native="checkValidateRequiredDes(component.name,component.name+'UserValue'+index, true)"
                                            >
                                            </b-input>
                                        </b-field>
                                    </div>
                                </div>
                                <p class="th is-size-7 mg-t-5 th"  :class="{'has-text-danger':valid[component.name].valid === true}">
                                    {{valid[component.name].valid === true?component.validation.errorMsg:component.display.description}}
                                </p>
                            </div>
                        </div>
                        <div :class="{custommentorinvest : component.display.label == 'Why do you want to be a volunteer?' || component.display.label == 'Are you interested in investing?' || component.display.label == 'Which size of investment you are?' , industindust : component.display.label == 'Industry Expertise?' }" v-if="component.type === 'checkbox' && checkMathId(component.display.matchid,matchId)" class="pd-3 has-text-left">
                            <div class="has-text-left pd-y-2">
                                <p  class="is-size-6 th" v-if="component.display.label !== ''">{{component.display.label}}</p>
                            </div>
                            <div style="position: relative; left: -5px;">
                                <div :class="{othercsss : value.label == 'Other' || value.label == 'Let me tell you'}"  v-for="(value,index) in component.display.value" :key="index" class="field" style="display:inline-block;padding: 0 15px;">
                                   
                                    <div class="is-flex align-center" >
                                        <!-- {{ checkModelValue[component.name].length }} -->
                                        <!-- {{ `value ${ changevalue(checkModelValue[component.name],'checkbox') }` }} -->
                                            <!-- :class="{checkboxactive : checkModelValue[component.name].length == 1 , checkboxnotactive : checkModelValue[component.name].length == 0}" -->
                          
                                        <b-checkbox 
                                            v-model="checkModelValue[component.name]"
                                            @change.native="setDataCheckBox(value.label,component.name,index,component.name+'UserValue'+index)"
                                            @input="checkValidateRequiredCheckBox(component.name,component.validation.required),$emit('setMatchId',checkModelValue[component.name],value,components)"
                                            :name="'input'+componentsIndex+componentDataIndex+component.name"
                                            :native-value="{label:value.label,value:value.value,userValue:value.userValue,index:index}"
                                            type="is-dark"
                                        >
                                            <p class="th">{{value.label}}</p>
                                        </b-checkbox>
                                            
                                        <b-field 
                                            v-if="value.userValue === true && checkModelValue[component.name].length !== 0 && checkValueCheckBox(value.label,checkModelValue[component.name]) === true" 
                                            :message="valid[component.name+'UserValue'+index].valid === true?'Please fill in a message.':''" 
                                            :type="valid[component.name+'UserValue'+index].valid === true?'is-danger':''"
                                            class="mg-l-2 mw-450 fixed-error-msg"
                                        > 
                                            <b-input 
                                                expanded
                                                :placeholder="value.label == 'Let me tell you' ? 'Your reason':''"
                                                icon-pack="fas"
                                                v-model="checkVarDes[component.name+index].des"
                                                @keyup.native="checkValidateRequiredArrayDes(component.name,value.label,$event.target.value,index,component.name+'UserValue'+index,true)"
                                            >
                                            </b-input>
                                        </b-field>
                                    </div>
                                </div>
                                <p class="th is-size-7 mg-t-5"  :class="{'has-text-danger':valid[component.name].valid === true}">
                                   
                                    <span>
                                        {{valid[component.name].valid === true?component.validation.errorMsg:component.display.description}}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                
                <FormInput
                    v-if="typeof components !== 'undefined'  && components.children.length > 0"
                    :propsComponentForm="components.children"
                    :stepIndex="stepIndex"
                    :depth="depth +1"
                    :validPorps="valid"
                    :inputValue="input"
                    :formId="formId"
                    :formType="formType"
                    :compeleteKey="compeleteKey"
                    :compeleteFormData="compeleteFormData"
                    :checkVarDes="checkVarDes"
                    :checkModelValue="checkModelValue"
                    :matchId="matchId"
                />
                <div class="columns is-marginless">  
                    <div v-if="depth === 0" class="column  is-12 has-text-centered">
                        <b-button @click="saveDataStep()" type="is-success" size="is-medium" class="buttonsucc">SAVE</b-button>
                    </div>
                </div>
            </div>

    </div>
</template>
<script>

import {HTTP,HTTPDynamic,HTTPMentor} from "@/axios.js";
import  FieldUpload  from "./FieldUpload";
import DatePicker from 'vue2-datepicker'
import FormInputData from './FormInputData'

export default {
    name:'FormInput',
    components:{
        FieldUpload,
        DatePicker,
        FormInputData,
    },
    props:[
        'propsComponentForm',
        'stepIndex',
        'depth',
        'validPorps',
        'inputValue',
        'formId',
        'formType',
        'compeleteKey',
        'compeleteFormData',
        'checkVarDes',
        'checkModelValue',
        'fetchDataForm',
        'matchId',
        'setMatchId',
    ],
    data(){
        return {
            picCurrent:'',
            input:{},
            valid:{},
            delFile:[],
            currencyUser:'',
            renderDropdown:true
        }
    },
    created() {
        this.valid = this.validPorps
        this.input = this.inputValue   
        if(this.input["nameMentor"] == '' || typeof this.input["nameMentor"] === 'undefined' || this.input["nameMentor"] === null ){
            this.input["nameMentor"] = this.islogin.detailUser[0].name
        }
        if(this.input["surenameMentor"] == '' || typeof this.input["surenameMentor"] === 'undefined' || this.input["surenameMentor"] === null){
            this.input["surenameMentor"] = this.islogin.detailUser[0].surname
        }
        if(this.input["emailMentor"] == '' || typeof this.input["emailMentor"] === 'undefined' || this.input["emailMentor"] === null){
            this.input["emailMentor"] = this.islogin.detailUser[0].email
        }
        if(this.input['telephoneNumberMentor'] == null){
            this.input['telephoneNumberMentor'] = ''
        }else{
          
        }

        //this.loadStepStore();
    },
    computed: {
        senddatamentor(){
            return this.$store.state.senddatamentor
        },
        islogin(){
            return this.$store.state.islogin
        },
        indent(){
            return {paddingLeft:`${this.depth * 20}px`}
        },
        getCountryDynamic(){
            return this.$store.getters.getCountryDynamic
        },
        getProvinceDynamic(){
            return this.$store.getters.getProvinceDynamic
        },
        token(){
            return this.$store.state.token
        },
        idlogin(){
            return this.$store.state.idlogin
        }
    },
    methods: {
        changeCurrent(value,name){

            this.input['hourlyRate'] = {}
            this.input['hourlyRate'] = value
            this.currencyUser = value
            this.renderDropdown= false
            console.log('value',value)
            console.log('name',name)
            console.log("this.input['hourlyRate']",this.input['hourlyRate'])
            this.renderDropdown= true
        },
        toLower(value){
            if(value == '' || value == null){
                return ''
            }else{
                return value.toLowerCase()
            }   
        },
        isvalue(label){
            console.log(label)
            if(label == 'Name'){
            return this.islogin.name
            }else if(label == 'Surname'){
            return this.islogin.surname
            }else if(label == 'E-mail'){
            return this.islogin.email
            }
        },  
        lang(options){
            return {
                days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
                placeholder: {
                    date: 'Select Date',
                    dateRange: 'Select Date Range'
                }
            }
        },
        checkMathId(matchid,displaymatchid){
            if(typeof displaymatchid !== 'undefined' && Object.values(displaymatchid).length > 0 && typeof matchid !== 'undefined'){
                let data = []
                Object.keys(displaymatchid).forEach((key) => {
                   if (displaymatchid[key] === matchid) {
                       data.push(displaymatchid[key])
                   } 
                });
                    
                return matchid === '' || data.length > 0
            }
            return true
        },
        regxValidate(allowEng,allowThai,specialChar,integer){
            // console.log("allowEng",allowEng,"allowThai",allowThai,"specialChar",specialChar,"integer",integer)
            let regx = /^[\w\W]+$/i
            if (allowEng===true && allowThai===true && specialChar===true && integer===true) {
                regx = /^[\w\W]+$/i
                //เอาทุกตัว
            }else if(allowEng===true && allowThai===true && specialChar===true && integer===false){
                regx=/^[^\d]+$/i
                //ไม่เอาตัวเลข
            }else if(allowEng===true && allowThai===true && specialChar===false && integer===true){
                regx = /^[\wก-๙]+$/i
                //ไม่เอาตัวอักษรพิเศษ
            }else if(allowEng===true && allowThai===true && specialChar===false && integer===false){
                regx = /^[a-zA-Zก-๙]+$/i
                //ไม่เอาตัวอักษรพิเศษและตัวเลข
            }else if(allowEng===true && allowThai===false && specialChar===true && integer===true){
                regx = /^[^ก-๙]+$/i
                //ไม่เอาภาษาไทย
            }else if(allowEng===true && allowThai===false && specialChar===true && integer===false){
                regx = /^[^ก-๙^0-9]+$/i
                //ไม่เอาภาษาไทยกับตัวเลข
            }else if(allowEng===true && allowThai===false && specialChar===false && integer===true){
                regx = /^[a-zA-Z0-9]+$/i
                //เอาแต่ภาษาอังกฤษและตัวเลข
            }else if(allowEng===true && allowThai===false && specialChar===false && integer===false){
                regx = /^[a-zA-Z]+$/i
                //เอาแต่ภาษาอังกฤษ
            }else if(allowEng===false && allowThai===true && specialChar===true && integer===true){
                regx = /^[^a-z^A-Z]+$/i
                //ไม่เอาภาษาอังกฤษ
            }else if(allowEng===false && allowThai===true && specialChar===true && integer===false){
                regx = /^[^a-z^A-Z^0-9]+$/i
                //ไม่เอาภาษาอังกฤษและตัวเลข
            }else if(allowEng===false && allowThai===true && specialChar===false && integer===true){
                regx = /^[ก-๙0-9]+$/i
                //ไม่เอาภาษาอังกฤษและตัวอักษรพิเศษ
            }else if(allowEng===false && allowThai===true && specialChar===false && integer===false){
                regx = /^[ก-๙]+$/i
                //เอาแต่ภาษาไทย
            }else if(allowEng===false && allowThai===false && specialChar===true && integer===true){
                regx = /^[^a-z^A-Z^ก-์]+$/i
                //เอาแต่ตัวอักษรพิเศษและตัวเลข
            }else if(allowEng===false && allowThai===false && specialChar===true && integer===false){
                regx = /^[^a-z^A-Z^ก-๙^0-9]+$/i
                //เอาแต่ตัวอักษรพิเศษ
            }else if(allowEng===false && allowThai===false && specialChar===false && integer===true){
                regx = /^[๐-๙0-9]+$/i
                //เอาแต่ตัวเลข
            }else if(allowEng===false && allowThai===false && specialChar===false && integer===false){
                regx = /^[^\w\W]+$/i
                //ไม่เอาซักตัว
            }else{
                regx = /^[\w\W]+$/i
            }

            return regx
        },
        checkValidatePhoneNumber(name,validation){
            let res = false

            if (validation === true) {     
                if (typeof this.input[name].countryCode !== 'undefined'  && typeof this.input[name].value !== 'undefined' &&  this.input[name].countryCode !== '' && this.input[name].countryCode !== null &&
                    this.input[name].value !== '' && this.input[name].value !== null && this.input[name].isValid === true){
                    res = false
                }else{
                       
                    res = true
                }
            }
            let obj = this.valid;
            obj[name]['valid'] = res;
            this.valid = Object.assign({}, this.valid, obj);

        },
        checkValidate(name,validation){  
           
            let res = false
            if (validation.required === true) {
                if (this.input[name] !== '' && this.input[name] !== null) {
                    let regx = this.regxValidate(validation.allowEng,validation.allowThai,validation.specialChar,validation.integer)
                    res = regx.test(this.input[name]) === true?false:true
                }else{
                    res = true
                }
              
            }else{
                if (this.input[name] !== '' && this.input[name] !== null) {
                    let regx = this.regxValidate(validation.allowEng,validation.allowThai,validation.specialChar,validation.integer)
                    res = regx.test(this.input[name]) === true?false:true
                }
            }


            let obj = this.valid;
            obj[name]['valid'] = res;
            this.valid = Object.assign({}, this.valid, obj);

        },
        checkValidateRequired(name,validation){

            let res = false

            if (validation === true) {
                       
                if (this.input[name] !== '' && this.input[name] !== null && this.input[name].length !== 0) {
                    res = false
                }else{
                       
                    res = true
                }
            }
            let obj = this.valid;
            obj[name]['valid'] = res;
            this.valid = Object.assign({}, this.valid, obj);

        },
        checkValidateRequiredObject(name,validation){
            let res = false
            if (validation === true) {
                       
                if (this.input[name].data !== '' && this.input[name].data !== null && this.input[name].length !== 0) {
                    res = false
                }else{
                       
                    res = true
                }
            }
            let obj = this.valid;
            obj[name]['valid'] = res;
            this.valid = Object.assign({}, this.valid, obj);

        },
        checkValidateRequiredCheckBox(name,validation){
            // console.log(name,' ',validation)
            // console.log(this.checkModelValue[name] !== '', this.checkModelValue[name] !== null , this.checkModelValue[name].length !== 0)
            let res = false
            if (validation === true) {
                if (this.checkModelValue[name] !== '' && this.checkModelValue[name] !== null && this.checkModelValue[name].length !== 0) {
                    res = false
                }else{
                    res = true
                }
            }

            let obj = this.valid;
            obj[name]['valid'] = res;
            this.valid = Object.assign({}, this.valid, obj);

        },
        checkValidateRequiredDes(name,valid,validation){
            let res = false
            if (validation === true) {
                if (typeof this.input[name]['des'] !=='undefined' && this.input[name]['des'] !== null  && this.input[name]['des'] !== '') {
                    res = false
                }else{
                    res = true
                }
            }
               
            let obj = this.valid;
                 
            obj[valid]['valid'] = res; 
            this.valid = Object.assign({}, this.valid, obj);

        },
        checkValidateRequiredArrayDes(name,label,input,indexValid,valid,validation){
            let res = false
            if (validation === true) {
                if (typeof this.checkVarDes[name+indexValid].des !=='undefined' && this.checkVarDes[name+indexValid].des !== null  && this.checkVarDes[name+indexValid].des !== '') {
                    res = false
                }else{
                    res = true
                }
            }
               
            
            let obj = this.valid;
            obj[valid]['valid'] = res; 
            this.valid = Object.assign({}, this.valid, obj);

        },
        setDataCheckBox(label,name,indexValid,valid){
           
            let data = this.checkModelValue[name].filter(item => item.label === label)
           
            for (let index = 0; index < this.checkModelValue[name].length; index++) {

                if (label === this.checkModelValue[name][index].label && typeof this.checkVarDes[name+indexValid] !== 'undefined') {

                    this.checkVarDes[name+indexValid].des = null
                }
            }


            if (data.length === 0 && typeof this.valid[valid] !=='undefined') {
                let obj = this.valid;
                obj[valid]['valid'] = false; 
                this.valid = Object.assign({}, this.valid, obj);
            }
        },
        checkValueCheckBox(label,value){
            let data = value.filter(item => item.label === label)
            if (data.length > 0) {
                return  true
            }else{
                return  false
            }
        },
        getSelectValue(choice,value){
            if(choice === 'custom'){
                return value
            }else if(choice === 'country'){
                return this.getCountryDynamic
            }else if(choice === 'province'){
                return  this.getProvinceDynamic
            }else{
                return []
            }
        },
        clearRadio(input,name,value){
            input.des = null

            value.map((item,index)=>{
                if (typeof this.valid[name+'UserValue'+index] !== 'undefined') {
                    this.valid[name+'UserValue'+index].valid = false
                }
            })

        },
        getData(obj) {
            let result = obj;
            if (typeof result !== 'undefined') {
               return Object.values(result); 
            }else{
                return null
            }
        },
        async loadStepStore(){
            let valid = []
            console.log('this.validthis.validthis.valid',this.valid)
            Object.keys(this.valid).forEach((key) => {
                if (this.valid[key].type === 'text' && this.valid[key].type === 'textarea') {
                   this.checkValidate(this.valid[key].name,this.valid[key].validation)
                   let check = (this.valid[key].valid === true && this.valid[key].hidden === false)?0:1
                   valid.push(check) 
                }else if (this.valid[key].type === 'select' && this.input[key] !== null && typeof this.input[key].countryCode !== 'undefined') {
                   this.checkValidatePhoneNumber(this.valid[key].name,this.valid[key].validation.required)
                   let check = (this.valid[key].valid === true && this.valid[key].hidden === false)?0:1
                   valid.push(check) 
                }else if (this.valid[key].type === 'radio') {
                   this.checkValidateRequiredObject(this.valid[key].name,this.valid[key].validation.required)
                   let check = (this.valid[key].valid === true && this.valid[key].hidden === false)?0:1
                   valid.push(check) 
                }else if (this.valid[key].type === 'radioDes') {
                    if (this.input[this.valid[key].name].data !== null && this.input[this.valid[key].name].data.userValue === true) {
                        this.checkValidateRequiredDes(this.valid[key].name,this.valid[key].name+'UserValue'+this.input[this.valid[key].name].data.index, true)
                        let check = (
                            this.valid[this.valid[key].name+'UserValue'+this.input[this.valid[key].name].data.index].valid === true &&
                            this.valid[this.valid[key].name+'UserValue'+this.input[this.valid[key].name].data.index].hidden === false
                        )?0:1
                        valid.push(check) 
                    } 
                }else if (this.valid[key].type === 'checkBoxDes') {

                     for (let index = 0; index < this.checkModelValue[this.valid[key].name].length; index++) {

                        if (this.checkModelValue[this.valid[key].name][index].userValue === true) {
                            
                            if (typeof this.checkModelValue !== 'undefined') {

                                this.checkValidateRequiredArrayDes(
                                    this.valid[key].name,
                                    this.checkModelValue[this.valid[key].name][index].label,
                                    this.checkVarDes[ this.valid[key].name+this.checkModelValue[this.valid[key].name][index].index].des,
                                    this.checkModelValue[this.valid[key].name][index].index,
                                    this.valid[key].name+'UserValue'+this.checkModelValue[this.valid[key].name][index].index,
                                    true
                                )
                                let check = (
                                    this.valid[this.valid[key].name+'UserValue'+this.checkModelValue[this.valid[key].name][index].index].valid === true &&
                                    this.valid[this.valid[key].name+'UserValue'+this.checkModelValue[this.valid[key].name][index].index].hidden === false
                                    )?0:1      
                                  
                                valid.push(check) 
                            }
                        } 
                    }

                    
                }else if (this.valid[key].type === 'checkbox') {
                        this.checkValidateRequiredCheckBox(this.valid[key].name,this.valid[key].validation.required)
                        let check = (this.valid[key].valid === true && this.valid[key].hidden === false)?0:1
                        valid.push(check) 

                        this.input[this.valid[key].name] = []
                        for (let index = 0; index < this.checkModelValue[this.valid[key].name].length; index++) {
                            let des = null
                            
                            if (typeof this.checkVarDes[this.valid[key].name+this.checkModelValue[this.valid[key].name][index].index] !== 'undefined') {
                                 des = this.checkVarDes[this.valid[key].name+this.checkModelValue[this.valid[key].name][index].index].des
                            }
                            
                    
                            this.input[this.valid[key].name].push({
                                value:this.checkModelValue[this.valid[key].name][index].value,
                                label:this.checkModelValue[this.valid[key].name][index].label,
                                userValue:this.checkModelValue[this.valid[key].name][index].userValue,
                                index:this.checkModelValue[this.valid[key].name][index].index,
                                des:des
                            })
                            
                        }
                
                }
                else{
                    this.checkValidateRequired(this.valid[key].name,this.valid[key].validation.required)
                    let check = (this.valid[key].valid === true && this.valid[key].hidden === false)?0:1
                    valid.push(check) 
                }

            });
            console.log("ghththghghgghgh",valid)
            console.log('Math.min(...valid)',Math.min(...valid))

                let complete = [] 
                complete = this.compeleteFormData

                 for (let x = 0; x < this.compeleteKey.length; x++) {
                    let data = this.compeleteFormData.filter(item => item === this.compeleteKey[x])
                    if (data.length === 0) {
                        complete.push(this.compeleteKey[x])
                    }
                 }  
                let arr = []
                let dataForm={
                    input:this.input,
                    complete:complete
                }
                // function sendmentor
                console.log('fdsnjkfewioufjhdesfiuysefjuhkjh',dataForm)
                // function sendmentor
                this.$store.commit('beforedataform',dataForm)
                console.log('statedataformsammary',this.$store.state.beforedataform)
                console.log('dataFormsammaryform',dataForm)            
        },
        ModalSuccess() {
          this.$notification.open({
            duration: 3000,
            message: 'Fill in is successful!<br>Please go next step from left menu',
            position: 'is-top',
            type: 'is-success',
            hasIcon: true,
            iconPack:'fas',
            icon:"check-square"
          })
        //   this.$toast.open({
        //             message: 'Fill in is successfull',
        //             type: 'is-success',
        //             hasIcon: true,
        //             iconPack:'fas',
        //             icon:"check-square"
        //         })
        },
        async saveDataStep(){
            let valid = []
            
            Object.keys(this.valid).forEach((key) => {
                if (this.valid[key].type === 'text' && this.valid[key].type === 'textarea') {
                   this.checkValidate(this.valid[key].name,this.valid[key].validation)
                   let check = (this.valid[key].valid === true && this.valid[key].hidden === false)?0:1
                   valid.push(check) 
                }else if (this.valid[key].type === 'radio') {
                   this.checkValidateRequiredObject(this.valid[key].name,this.valid[key].validation.required)
                   let check = (this.valid[key].valid === true && this.valid[key].hidden === false)?0:1
                   valid.push(check) 
                }else if (this.valid[key].type === 'radioDes') {
                    if (this.input[this.valid[key].name].data !== null && this.input[this.valid[key].name].data.userValue === true) {
                        this.checkValidateRequiredDes(this.valid[key].name,this.valid[key].name+'UserValue'+this.input[this.valid[key].name].data.index, true)
                        let check = (
                            this.valid[this.valid[key].name+'UserValue'+this.input[this.valid[key].name].data.index].valid === true &&
                            this.valid[this.valid[key].name+'UserValue'+this.input[this.valid[key].name].data.index].hidden === false
                        )?0:1
                        valid.push(check) 
                    } 
                }else if (this.valid[key].type === 'checkBoxDes') {

                     for (let index = 0; index < this.checkModelValue[this.valid[key].name].length; index++) {

                        if (this.checkModelValue[this.valid[key].name][index].userValue === true) {
                            
                            if (typeof this.checkModelValue !== 'undefined') {

                                this.checkValidateRequiredArrayDes(
                                    this.valid[key].name,
                                    this.checkModelValue[this.valid[key].name][index].label,
                                    this.checkVarDes[ this.valid[key].name+this.checkModelValue[this.valid[key].name][index].index].des,
                                    this.checkModelValue[this.valid[key].name][index].index,
                                    this.valid[key].name+'UserValue'+this.checkModelValue[this.valid[key].name][index].index,
                                    true
                                )
                                let check = (
                                    this.valid[this.valid[key].name+'UserValue'+this.checkModelValue[this.valid[key].name][index].index].valid === true &&
                                    this.valid[this.valid[key].name+'UserValue'+this.checkModelValue[this.valid[key].name][index].index].hidden === false
                                    )?0:1      
                                  
                                valid.push(check) 
                            }
                        } 
                    }

                    
                }else if (this.valid[key].type === 'checkbox') {
                        this.checkValidateRequiredCheckBox(this.valid[key].name,this.valid[key].validation.required)
                        let check = (this.valid[key].valid === true && this.valid[key].hidden === false)?0:1
                        valid.push(check) 

                        this.input[this.valid[key].name] = []
                        for (let index = 0; index < this.checkModelValue[this.valid[key].name].length; index++) {
                            let des = null
                            
                            if (typeof this.checkVarDes[this.valid[key].name+this.checkModelValue[this.valid[key].name][index].index] !== 'undefined') {
                                 des = this.checkVarDes[this.valid[key].name+this.checkModelValue[this.valid[key].name][index].index].des
                            }
                            
                    
                            this.input[this.valid[key].name].push({
                                value:this.checkModelValue[this.valid[key].name][index].value,
                                label:this.checkModelValue[this.valid[key].name][index].label,
                                userValue:this.checkModelValue[this.valid[key].name][index].userValue,
                                index:this.checkModelValue[this.valid[key].name][index].index,
                                des:des
                            })
                            
                        }
                
                }
                else{
                    this.checkValidateRequired(this.valid[key].name,this.valid[key].validation.required)
                    let check = (this.valid[key].valid === true && this.valid[key].hidden === false)?0:1
                    valid.push(check) 
                }

            });

            console.log('Math.min(...valid)',Math.min(...valid))
            if (Math.min(...valid) > 0) {  

                let complete = [] 
                complete = this.compeleteFormData

                for (let x = 0; x < this.compeleteKey.length; x++) {
                    let data = this.compeleteFormData.filter(item => item === this.compeleteKey[x])
                    if (data.length === 0) {
                        complete.push(this.compeleteKey[x])
                    }
                }
                           
                let arr = []

                let dataForm={
                    input:this.input,
                    complete:complete
                }
                // function sendmentor
                

                // function sendmentor

                if(dataForm.input.profileLogoMentor.name == null || dataForm.input.profileLogoMentor.name.length == 0){
                    dataForm.input.profileLogoMentor.name=this.islogin.detailUser[0].profilePic
                }

                // this.$dialog.confirm({
                //     message: 'คุณต้องการบันทึกข้อมูลหรือไม่ ?',
                //     onConfirm: () => {
                this.$store.commit('beforedataform',dataForm)
                            // this.$store.commit('formId',this.formId)
               
                            // this.$router.push('/submitmentor')
                //             this.$toast.open('Preview')
                //         }
                // }) 
                console.log('statedataformsammary',this.$store.state.beforedataform)
                console.log('dataFormsammaryform',dataForm)

                let data = {
                    componentId:this.formId,
                    companyId:this.idlogin,
                    data:dataForm,
                    roleId:'mentor',
                    keyRequest:this.token
                }

                console.log("create/data/form/prod", data); 
                HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;  
                HTTPDynamic.post(`create/data/form/prod`,data)
                .then(res => {
                    console.log("create/data/form/prod", res);  
                    if (res.data.success) {
                        
                        if (typeof this.dataKpi !== 'undefined' && 
                        typeof this.dataInputKpi !== 'undefined' &&
                        Object.values(this.dataInputKpi).length !==0) {
                            this.saveKpi() 
                        }
                        
                        if (this.delFile.length > 0) {
                            this.delFileUpload()
                        }
                        this.senddatatomentor(dataForm)
                        this.ModalSuccess()
                        console.log('this.senddatamentor',this.senddatamentor)
                        HTTPMentor.defaults.headers.common.Authorization = `Bearer ${this.islogin.token}`
                        HTTPMentor.post(`create/detail/user`,this.senddatamentor).then(res => { 
                            console.log('create/detail/user',this.senddatamentor)
                          if(res.data.success){
                            console.log('create/detail/user',res)
                            this.$emit('fetchDataForm')
                            let update ={
                                key:'detailUser',
                                value:this.senddatamentor.detailUser
                            }
                            this.$store.commit('updateUser',update)
                            this.phoneNumber = this.input['telephoneNumberMentor'] 
                          }else{
                            this.$dialog.alert(`<p class="has-text-centered is-size-5">${res.data.message}</p>`);
                          }
                        })
                        .catch(e => {
                            console.log("api/add/kpi/error",e);
                            this.$dialog.alert('<p class="has-text-centered is-size-5">Please check your network connection</p>');
                         });

                        
                    }else{
                    this.$dialog.alert('<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่</p>');
                    }
                    
                })
                .catch(e => {
                    console.log("create/data/form/error",e);
                    this.$dialog.alert('<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>');
                });

                
            }else{
                this.$emit('setRenderComponent',false)
                this.$dialog.alert('<p class="has-text-centered is-size-5">Please complete the information.</p>');
            }   
        },
        senddatatomentor(dataForm){
            console.log('datadatadatadata',dataForm)
            console.log('dataFormdataForm',dataForm.input.whoAreYou)
            var mentorinvestment = {
                mentor:false,
                investment:false,
            }
            
            for (let d = 0; d < dataForm.input.whoAreYou.length; d++) {
                if(dataForm.input.whoAreYou[d].value == 'mentor'){
                    mentorinvestment.mentor = true
                }
                if(dataForm.input.whoAreYou[d].value == "investor"){
                    mentorinvestment.investment = true
                }
            }
           var volunteer =  dataForm.input.wantVolunteer.map(obj =>{ 
                var data = {};
                data['index'] = obj.index;
                data['name'] = obj.value;
                return data;
            })
            console.log('volunteervolunteer',volunteer)

            var industryInterested = dataForm.input.areYouInterestedInInvesting.map(obj =>{ 
                var data = {};
                data['index'] = obj.index;
                data['name'] = obj.label;
                return data;
            })
            
            // console.log('dataForm.input.whichSizeOfInvestment',dataForm.input.whichSizeOfInvestment)
            var sizeInvestment = dataForm.input.whichSizeOfInvestment.map(obj =>{ 
                var data = {};
                data['index'] = obj.index;
                data['name'] = obj.label;
                return data;
            })

            var language = dataForm.input.talkWellInMentor.map(obj =>{ 
                var data = {};
                data['index'] = obj.index;
                data['name'] = obj.label;
                return data;
            })

            var industryExpertise =  dataForm.input.industryexpertise.map(obj =>{ 
                var data = {};
                data['index'] = obj.index;
                data['name'] = obj.label;
                return data;
            })
            console.log('industryExpertiseindustryExpertiseindustryExpertise',industryExpertise)

        var gender = ''
        if( dataForm.input.genderMentor.data != null){
            gender = dataForm.input.genderMentor.data.label == 'Male' ? 1 : 2
        }
        
        var hourlyRate = ''
        if(dataForm.input.hourlyRate != null){
            hourlyRate = dataForm.input.hourlyRate.label
        }
        //console.log('dataForm.input.hourlyRate.label',dataForm.input.hourlyRate.label)
        //console.log('gendergendergender',gender)
            
           let dataform =  {
            userId:this.idlogin,
            detailUser:[
			{    mentor:mentorinvestment.mentor,
				investment: mentorinvestment.investment,
				volunteer,
				hourlyRate,
                email:dataForm.input.emailMentor,
				amountHourly: dataForm.input.hourlyRateAmount,
				industryInterested: industryInterested,
				sizeInvestment,
                name:dataForm.input.nameMentor,
                surname:dataForm.input.surenameMentor,
				nickName : dataForm.input.nicknameMentor,
				dateOfBirth : dataForm.input.dateofBirthMentor,
                living: (typeof dataForm.input.livingMentor !== 'undefined' && dataForm.input.livingMentor != null) ? dataForm.input.livingMentor :'' ,
				cityDistrict: dataForm.input.livingInMentor != null ? dataForm.input.livingInMentor.label : '',
				country: dataForm.input.countryMentor != null ? dataForm.input.countryMentor.label : '',
				gender,// 1male // 2female
				telephoneNumber: dataForm.input.countryCode+''+dataForm.input.telephoneNumberMentor, // !
				websit: dataForm.input.websiteMentor,
				profilePic: dataForm.input.profileLogoMentor.name,
				aboutMe: dataForm.input.anoutMe,
				professionTitle: dataForm.input.professionTitle,
				social: {
					facebook: dataForm.input.facebookMentor,
					linkedin:dataForm.input.linkedinMentor,
					line: dataForm.input.lineMentor,
					skype: dataForm.input.skypeMentor,
					hangouts:dataForm.input.hangoutsMentor,
					zoom: dataForm.input.zoomMentor
				},
				language,
				industryExpertise,
			 }
                    ]
            }
            this.$store.commit('senddatamentor',dataform)
            console.log('dataformdataformdataform',dataform)
        },
        saveKpi(){
            let kpiData = {}
          
            Object.keys(this.input).forEach((key) => {
                if (typeof this.dataInputKpi[key] !== 'undefined') {
                    kpiData[key] =  {type:this.dataInputKpi[key].type,input:this.input[key],lastUpdate:new Date(),repeat:this.dataInputKpi[key].repeat,nameLabel:this.dataInputKpi[key].nameLabel} 
                }
            });
                                  
            Object.keys(this.dataKpi).forEach((key) => {
                if (typeof kpiData[key] === 'undefined') {
                    kpiData[key] =  {type:this.dataKpi[key].type,input:this.dataKpi[key].input,lastUpdate:new Date(this.dataKpi[key].lastUpdate),repeat:this.dataKpi[key].repeat,nameLabel:this.dataKpi[key].nameLabel}
                }
            });

            console.log("ASdasdsadasdasdsad",this.dataInputKpi,this.dataKpi)

            let data={
                    componentId:this.formId,
                    companyId:(this.getRule === 'startup')?this.user._id:this.startupId,
                    batchId:this.batchId,
                    kpi:kpiData
                }
              console.log("api/add/kpi/res", data);       
            HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;  
            HTTPDynamic.post(`api/add/kpi`,data)
            .then(res => {
                console.log("api/add/kpi", res);  
            })
            .catch(e => {
                console.log("api/add/kpi/error",e);
                this.$dialog.alert('<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>');
            });
        },
        delFileUpload(){

            const data ={
                files:this.delFile
            }

            HTTPDynamic.defaults.headers.common.Authorization = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IiIsIl9pZCI6IjVjY2JmMGI4OTRiY2I1MjQ3MjI3M2FiYyIsImFsZyI6IkhTMjU2IiwiaWF0IjoxNTU3NzQwMTAyfQ.NGduJrRb52x5iBuh_r3_Ka6Qdx9w4U4dZQB5KNxWnJY`; 
            HTTPDynamic.post(`delete/file`,data)
            .then(res => {
                console.log("delete/file", res);  
                if (res.data.success) {
                    
                }else{
                    this.$dialog.alert('<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่</p>');
                }
            })
            .catch(e => {
                console.log("delete/file/error",e);
                this.$dialog.alert('<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>');
            });
        },

    },
    
    
}
</script>
<style scoped>
.cursor-down{
    position: absolute;
    right: 15px;
}
.dropdown{
    display: block!important;
}
.basicprofile .w-60{
    width:100% !important;
}
.basicprofile .gendercss .pd-3 div{
    max-width: 50% !important;
    width: 50% !important;
}
.basicprofile div.control {
    width: 100%;
}
.basicprofile .defaultcss:nth-child(n+2){
    width:50%;
    display: inline-block;
}

.basicprofile .mx-datepicker{
    width: 100%;
}
.gendercsstitle{
    width:50%;
    display: inline-block;
}
 
.gendercss .field{
    max-width: 50% !important;
    width: 50%  !important;
    display:inline-block;
}
/* input{
    width:100% !important;
} */
.buttonsucc{
    background: linear-gradient(180deg, #FD7900 -34.44%, #FFCB2A 133.33%);
 padding-left: 3rem !important;
    padding-right: 3rem !important;
    border-radius: 40px;
    opacity: 0.6;
}
.buttonsucc:hover{
    opacity: 1;
}
.fontbold2{
    color: black;
    font-size: 24px !important;
    font-weight: bold !important;
}
     .b-checkbox.checkbox input[type=checkbox]:indeterminate + .check.is-dark {
        background: red url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Crect style='fill:whitesmoke' width='0.7' height='0.2' x='.15' y='.4'%3E%3C/rect%3E%3C/svg%3E") no-repeat center center !important;
        border-color: #363636 !important; }
    span.is-dark{
    position: absolute;
    right: -10px;
    top: -10px; 
    border-radius: 30px;
    }
    .span.check.is-dark{
    background: red;
    }
    .mw-500{
        position: relative;
        min-width: 500px!important;
    }
    .mw-450{
        position: relative;
        min-width: 500px!important;
    }
    .mw-200{
        position: relative;
        min-width: 200px!important;
    }
    .checkboxactive{
        border: 1px solid #0FB9F4 !important;
    }
    .checkboxnotactive{
            border: 1px solid rgba(0,0,0,0.25) !important
    }
    .deltransform{
        margin-top: 17px !important;
           transform: translate(-20px) !important;
    }
    
    .customhourandperhour{
        width:50%;
        display:inline-block;
    }

    .customhourandperhour .has-text-left{
        width:100% !important;
    }
    .hourrate{
            width: 25%;
    display: inline-block;
    white-space: nowrap;
  
    }
    .hourrate .w-60{
        width: 100% !important;
    position: relative;
    }
    .w-100 .dropdown-trigger{
        width: 100%!important;
    }
    .perrate .w-60{
            width: 100% !important;
    }
    

    .hourrate div.control{
        width:100%;
    }
    .perrate{
        width: 64%;
    display: inline-block;
    position: relative;

    }
    .perrate .field{
        position: relative
    }
    
    .perrate div.control{
        width:100%;
    }

    .introductioncss .w-60{
  width: 100% !important;
}
.list-menu{
    height: 340px!important;
    overflow-y: auto!important;
}

.button:focus{
    border-color: #0FB9F4 !important;
    -webkit-box-shadow: 0 0 0 0.125em rgba(15, 185, 244, 0.25) !important;
}
/*.Languagecss .field{
    padding: 5px 15px!important;
}*/

.Languagecss .control-label{
    padding:5px 15px;
}
.websitebasicprofile{
    display: block !important;
}

.Othertitle{
 width:100% !important; 
}

.Othertitle div.control{
    width:100% !important;
}
</style>
<style>
.introductioncss div.control,.Languagecss .b-checkbox.checkbox,.Languagecss .control-label{
    width: 100% !important;   
}
.whoareu .field,.loveVolunteer .field{
    width: 50%;
}
 .whoareu .b-checkbox.checkbox,.loveVolunteer .b-checkbox.checkbox{
     width: 100%;
 }
.whoareu .checkbox .control-label,.loveVolunteer .checkbox .control-label{
 width: 100% !important;
}
.perrate p.help{
        position: absolute;
       right: -64px;
        top: 0;
    }
    .help.is-danger{
       right: 0 !important;
    top: 0px !important; 
    }
    .othercsss .help.is-danger{
        position: absolute !important;
        height: 18px;
        right: 95px !important;
    }
    
.custommentorinvest .b-checkbox.checkbox{
    width:100%;
}
.dialog .modal-card .modal-card-foot{
   justify-content: center!important;
}
.custommentorinvest .b-checkbox.checkbox .control-label{
    width: 100% !important;
   padding: 10px 1rem !important;
}
@media only screen and (max-width: 767px) {
    .custommentorinvest .field{
        width: 50%
    }
    .perrate p.help{
        display: block;
        position: relative;
        left: 0;
    }
    .hourrate{
        width: 100% !important;
        left: 0% !important;
     }
    .perrate{
        width: 100%!important;
        left: 0%!important;
    }
}

</style>
